var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveTypeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 5,
    width: 18,
    height: 14,
    rx: 2.5,
    stroke: "#2563EB",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 8,
    width: 1.4,
    height: 1.4,
    rx: 0.7,
    fill: "#2563EB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 8,
    width: 1.4,
    height: 1.4,
    rx: 0.7,
    fill: "#2563EB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 8,
    width: 1.4,
    height: 1.4,
    rx: 0.7,
    fill: "#2563EB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 8,
    width: 1.4,
    height: 1.4,
    rx: 0.7,
    fill: "#2563EB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 11,
    width: 1.4,
    height: 1.4,
    rx: 0.7,
    fill: "#2563EB"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 11,
    width: 1.4,
    height: 1.4,
    rx: 0.7,
    fill: "#2563EB"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 11,
    width: 1.4,
    height: 1.4,
    rx: 0.7,
    fill: "#2563EB"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 11,
    width: 1.4,
    height: 1.4,
    rx: 0.7,
    fill: "#2563EB"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 15,
    width: 8,
    height: 1.6,
    rx: 0.8,
    fill: "#2563EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveTypeIcon);
export default __webpack_public_path__ + "static/media/active-type-icon.6fd627754d1d45b58e75af04a5bf2b7d.svg";
export { ForwardRef as ReactComponent };